module.exports = __webpack_public_path__ + "img/tip.7a41dbb9.png";